import {Box, BranchName, Truncate} from '@primer/react'
import type {TooltipProps} from '@primer/react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import {CopyToClipboardButton} from '@github-ui/copy-to-clipboard'
import type {Branch} from '../types'
import BranchProtectionShield from './BranchProtectionShield'
import TruncatedBranchName from './TruncatedBranchName'
import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'

interface BranchDescriptionProps
  extends Pick<Branch, 'name' | 'path' | 'rulesetsPath' | 'protectedByBranchProtections'> {
  isLarge?: boolean
  sx?: BetterSystemStyleObject
}

export default function BranchDescription({isLarge = false, sx = {}, ...branch}: BranchDescriptionProps) {
  const fancyTruncation = useFeatureFlag('fancyTruncation')
  const direction: TooltipProps['direction'] = !isLarge && branch.name.length < 3 ? 'ne' : undefined
  return (
    <Box
      sx={{
        ...sx,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        height: BranchDescriptionHeight,
      }}
    >
      {fancyTruncation ? (
        <TruncatedBranchName {...branch} />
      ) : (
        <BranchName href={branch.path}>
          {/* eslint-disable-next-line primer-react/no-system-props */}
          <Truncate title={branch.name} maxWidth={250}>
            {branch.name}
          </Truncate>
        </BranchName>
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <CopyToClipboardButton
          sx={{display: 'flex', justifyContent: 'center', width: BranchDescriptionHeight}}
          textToCopy={branch.name}
          ariaLabel="Copy branch name to clipboard"
          tooltipProps={{direction}}
          hasPortalTooltip={true}
        />
        <BranchProtectionShield {...branch} isLarge={isLarge} />
      </Box>
    </Box>
  )
}

export const BranchDescriptionHeight = 32

try{ BranchDescription.displayName ||= 'BranchDescription' } catch {}